import * as fullscreenSelectors from './fullscreen.selectors';
import * as sidecarSelectors from './sidecar.selectors';

interface Releasable {
    release(): void;
}

const hasRelease = (value: unknown): value is Releasable => typeof value === 'function' && typeof (value as Partial<Releasable>).release === 'function';

/**
 * The fullscreen/sidecar selectors are only sampled while a fullscreen dialog is open (or one-shot
 * via concatLatestFrom in effects), so their memoized lastResult/lastArguments pin entire
 * generations of the record maps long after they were last needed. Releasing them drops those
 * stale references (release() propagates to parent selectors); actively subscribed selectors
 * simply recompute on the next store emission.
 */
export const releaseFullscreenSelectors = (): void => {
    for (const selectors of [fullscreenSelectors, sidecarSelectors]) {
        for (const exported of Object.values(selectors)) {
            if (hasRelease(exported)) {
                exported.release();
            }
        }
    }
};
